import {
  Box,
  type SxProps,
  type Theme,
  Typography,
  useTheme,
} from "@mui/material";
import { CheckCircleIcon } from "components/icons";

interface OnboardingSelectionCardProps {
  title: string;
  description: string;
  isSelected: boolean;
  onClick: () => void;
}

const getCardSx = (theme: Theme, isSelected: boolean): SxProps<Theme> => ({
  padding: "16px",
  borderRadius: "8px",
  border: "1px solid",
  borderColor: isSelected
    ? theme.palette.secondary["purple-tint"]
    : theme.palette.primitive.neutrals.neutral[800],
  backgroundColor: isSelected ? "rgba(135, 145, 248, 0.05)" : "transparent",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "12px",
  cursor: "pointer",
  transition: "all 0.2s ease",
  "&:hover": {
    borderColor: isSelected
      ? theme.palette.secondary["purple-tint"]
      : theme.palette.primitive.neutrals.neutral[600],
  },
});

export const OnboardingSelectionCard = ({
  title,
  description,
  isSelected,
  onClick,
}: OnboardingSelectionCardProps): JSX.Element => {
  const theme = useTheme();

  const handleKeyDown = (e: React.KeyboardEvent): void => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <Box
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      sx={getCardSx(theme, isSelected)}
      aria-pressed={isSelected}
      aria-label={title}
    >
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <Typography
          variant="subtitle1"
          // color={
          //   isSelected
          //     ? theme.palette.primitive.neutrals.neutral["500"]
          //     : "inherit"
          // }
          color="inherit"
        >
          {title}
        </Typography>
        <Typography variant="body-small" color="inherit">
          {description}
        </Typography>
      </Box>
      {isSelected && (
        <CheckCircleIcon
          sx={{
            fontSize: 22,
            color: theme.palette.secondary["purple-tint"],
            flexShrink: 0,
          }}
        />
      )}
    </Box>
  );
};
